import GoogleConnected from "./GoogleConnected";

export default GoogleConnected;
